/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent, memo } from "react";

type Props = {
  className?: string;
};

const Logo: FunctionComponent<Props> = ({ className }) => (
  <svg
    className={clsx("block aspect-square tw-print-color-adjust", className)}
    fill="#E10A1D"
    viewBox="0 0 125 110"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.64 29.5C40.3 29.5 23 40.693 23 54.494 23 68.304 40.301 79.5 61.64 79.5c21.339 0 38.64-11.193 38.64-25.006 0-13.814-17.301-24.994-38.64-24.994Zm0 39.271c-3.175 0-5.764-6.253-5.925-14.12 3.942.346 7.907.346 11.85 0-.161 7.864-2.75 14.12-5.925 14.12Zm-5.535-20.363c.863-5.561 3.017-9.509 5.535-9.509 2.518 0 4.669 3.948 5.535 9.509a62.585 62.585 0 0 1-11.07 0Zm5.535-15.295c-4.144 0-7.68 6.208-8.984 14.873-7.857-1.224-13.34-4.019-13.34-7.264 0-4.38 9.994-7.925 22.324-7.925 12.332 0 22.324 3.549 22.324 7.925 0 3.245-5.484 6.04-13.34 7.264-1.304-8.662-4.84-14.87-8.984-14.87v-.003ZM28.538 53.56c0-4.235 1.633-8.211 4.47-11.624a6.065 6.065 0 0 0-.049.727c0 5.336 8.002 9.886 19.169 11.56-.01.386-.01.78-.01 1.172 0 9.95 2.789 18.37 6.643 21.23-16.937-1.021-30.223-10.958-30.223-23.065Zm35.98 23.065c3.855-2.86 6.643-11.283 6.643-21.23 0-.396-.006-.782-.01-1.169 11.161-1.674 19.17-6.22 19.17-11.563 0-.244-.02-.49-.049-.727 2.837 3.422 4.466 7.39 4.466 11.624 0 12.107-13.282 22.044-30.22 23.065Z"
      fill="#fff"
    />
  </svg>
);

export const ToyotaLogo = memo(Logo);
